<!-- loader.component.html -->
<div class="progress-loader" [hidden]="!loading">
  <mat-progress-spinner [mode]="'indeterminate'" diameter="40">
  </mat-progress-spinner>
</div>